import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class ClassBehaviour extends AbstractDataAttributeBehaviour {
    attrSelectors = {
        container: 'data-class',
    };

    defaultConfig = {
        add: {},
        remove: {},
        toggle: {}
    }
    getContainerSelector()
    {
        return '[' + this.attrSelectors.container + ']';
    }

    getConfig(container) {
        return {...this.defaultConfig, ...JSON.parse(container.getAttribute(this.attrSelectors.container))};
    }

    handleConfig(selectors, callback) {
        Object.keys(selectors).forEach( key => {
            let className = selectors[key];
            let elements = document.querySelectorAll(key);
            elements.forEach( element => {
                callback(element, className);
            })
        });
    }

    removeClass(selectors) {
        this.handleConfig(selectors, (element, className) => {
            element.classList.remove(className);
        })
    }

    addClass(selectors) {
        this.handleConfig(selectors, (element, className) => {
            if (!element.classList.contains(className)) element.classList.add(className);
        })
    }

    toggleClass(selectors) {
        this.handleConfig(selectors, (element, className) => {
            element.classList.toggle(className);
        })
    }
    initContainer(container)
    {
        let config = this.getConfig(container);

        container.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.removeClass(config.remove);
            this.addClass(config.add);
            this.toggleClass(config.toggle);
        });
    }
}